module.exports = __webpack_public_path__ + "img/EC.b4e23b27.svg";